/* Native Immersive Viewer — full parity with the Render widget immersive view.
 * Mobile  = fullscreen scroll-snap feed + product tray.
 * Desktop = dark-overlay 2-col dialog with prev/next + keyboard + wheel nav.
 * All behaviour is driven by a config object (the same flags exposed in the
 * Render back office), passed per-trigger via a [data-ni-config] JSON ancestor
 * or window.NativeImmDefaults. Products are fetched natively via
 * /products/<handle>.js (no Render dependency).
 * x/y on-image hotspots intentionally omitted (excluded from current scope). */
(function () {
  "use strict";

  /* ── i18n labels ──────────────────────────────────────────────────────────── */
  var _lang = ((document.documentElement.lang || "it").toLowerCase() + "  ").slice(0, 2);
  var _labels = {
    it: { add: "Aggiungi", addLook: "Aggiungi tutto", saveLook: "Salva il look", loading: "Caricamento…", shop: "Acquista il look →", noSize: "Nessuna taglia disponibile", added: "Aggiunto ✓", saved: "Salvato ✓", view: "Scopri", products: "prodotti", product: "prodotto", confirmTitle: "Conferma le taglie", confirmBtn: "Aggiungi al carrello", cancel: "Annulla", share: "Condividi", linkCopied: "Link copiato", adding: "Aggiunta…", notify: "Avvisami quando disp.", eyebrow: "Scopri il look", addLookCart: "Aggiungi tutto al carrello", lookTotal: "Totale look:", saveAmt: "Risparmi", viewProduct: "Vedi prodotto", moreDetails: "Vedi più dettagli", sizeLabel: "Taglia", sizeGuide: "Guida taglie" },
    en: { add: "Add", addLook: "Add whole look", saveLook: "Save look", loading: "Loading…", shop: "Shop this look →", noSize: "No size available", added: "Added ✓", saved: "Saved ✓", view: "View", products: "products", product: "product", confirmTitle: "Confirm your sizes", confirmBtn: "Add to cart", cancel: "Cancel", share: "Share", linkCopied: "Link copied", adding: "Adding…", notify: "Notify me", eyebrow: "Shop the look", addLookCart: "Add everything to cart", lookTotal: "Look total:", saveAmt: "You save", viewProduct: "View product", moreDetails: "See more details", sizeLabel: "Size", sizeGuide: "Size guide" },
    es: { add: "Añadir", addLook: "Añadir todo el look", saveLook: "Guardar look", loading: "Cargando…", shop: "Compra el look →", noSize: "Sin talla disponible", added: "Añadido ✓", saved: "Guardado ✓", view: "Ver", products: "productos", product: "producto", confirmTitle: "Confirma tus tallas", confirmBtn: "Añadir al carrito", cancel: "Cancelar", share: "Compartir", linkCopied: "Enlace copiado", adding: "Añadiendo…", notify: "Avísame", eyebrow: "Compra el look", addLookCart: "Añadir todo al carrito", lookTotal: "Total del look:", saveAmt: "Ahorras", viewProduct: "Ver producto", moreDetails: "Ver más detalles", sizeLabel: "Talla", sizeGuide: "Guía de tallas" },
    fr: { add: "Ajouter", addLook: "Ajouter tout le look", saveLook: "Sauvegarder", loading: "Chargement…", shop: "Acheter le look →", noSize: "Taille indisponible", added: "Ajouté ✓", saved: "Sauvegardé ✓", view: "Voir", products: "produits", product: "produit", confirmTitle: "Confirmez vos tailles", confirmBtn: "Ajouter au panier", cancel: "Annuler", share: "Partager", linkCopied: "Lien copié", adding: "Ajout…", notify: "Prévenez-moi", eyebrow: "Shop the look", addLookCart: "Tout ajouter au panier", lookTotal: "Total du look :", saveAmt: "Vous économisez", viewProduct: "Voir le produit", moreDetails: "Voir plus de détails", sizeLabel: "Taille", sizeGuide: "Guide des tailles" },
    de: { add: "Hinzufügen", addLook: "Ganzen Look", saveLook: "Look speichern", loading: "Lädt…", shop: "Look kaufen →", noSize: "Keine Größe verfügbar", added: "Hinzugefügt ✓", saved: "Gespeichert ✓", view: "Ansehen", products: "Produkte", product: "Produkt", confirmTitle: "Größen bestätigen", confirmBtn: "In den Warenkorb", cancel: "Abbrechen", share: "Teilen", linkCopied: "Link kopiert", adding: "Wird hinzugefügt…", notify: "Benachrichtigen", eyebrow: "Shop the look", addLookCart: "Alles in den Warenkorb", lookTotal: "Look-Summe:", saveAmt: "Sie sparen", viewProduct: "Produkt ansehen", moreDetails: "Mehr Details", sizeLabel: "Größe", sizeGuide: "Größentabelle" }
  };
  var _t = _labels[_lang] || _labels.it;

  /* ── Analytics (Google Analytics: gtag + GTM dataLayer) ───────────────────── */
  function _ga(name, params) {
    try {
      if (typeof window.gtag === "function") window.gtag("event", name, params || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
    } catch (e) {}
  }

  /* ── Config (mirrors Render back-office immersive flags) ──────────────────── */
  var DEFAULTS = {
    theme: "dark",           // 'dark' | 'light'
    progressBar: true,       // top completion segments (mobile)
    cartConfirm: true,       // size-confirmation popup before "add whole look"
    trayHint: true,          // auto-peek + pulse the tray on first post (mobile)
    doubtRemovers: true,     // trust line under products
    doubtText: "Resi gratuiti 15 gg · Spedizione gratuita sopra €50",
    dragTray: true,          // grabber handle on the mobile tray
    deepLinkShare: true,     // share button
    doubleTapSave: true      // double-tap the image to save the look (mobile)
  };
  var _cfg = Object.assign({}, DEFAULTS);
  var _isDesktop = false;   // set per-open() — gates the desktop-only premium panel markup

  function _resolveConfig(el, override) {
    var cfg = Object.assign({}, DEFAULTS);
    if (window.NativeImmDefaults) cfg = Object.assign(cfg, window.NativeImmDefaults);
    if (el) {
      var host = el.closest ? el.closest("[data-ni-config]") : null;
      if (host) {
        try { cfg = Object.assign(cfg, JSON.parse(host.getAttribute("data-ni-config"))); } catch (e) {}
      }
    }
    if (override) cfg = Object.assign(cfg, override);
    return cfg;
  }

  /* ── CSS (injected once) ──────────────────────────────────────────────────── */
  var _cssInjected = false;
  function _injectCss() {
    if (_cssInjected) return;
    _cssInjected = true;
    var style = document.createElement("style");
    style.textContent = [
      ".ni-iv{position:fixed;inset:0;z-index:99999;background:#0a0a0a;overflow:hidden;animation:ni-fadein .25s ease}",
      ".ni-iv.ni-light{background:#f2f2f2}",
      "@keyframes ni-fadein{from{opacity:0}to{opacity:1}}",
      ".ni-iv-desktop{background:rgba(0,0,0,.82);overflow:visible;display:flex;flex-direction:column;align-items:center;justify-content:center;padding-top:76px;padding-bottom:24px;box-sizing:border-box}",
      ".ni-iv-desktop.ni-light{background:rgba(40,40,40,.55)}",
      /* header */
      ".ni-iv-header{position:fixed;top:12px;left:12px;right:12px;z-index:100001;height:52px;display:flex;align-items:center;justify-content:space-between;padding:0 16px;background:#fff;border-radius:14px;box-shadow:0 4px 24px rgba(0,0,0,.18)}",
      ".ni-iv-header-home,.ni-iv-close,.ni-iv-header-share{width:38px;height:38px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:transparent;border:none;cursor:pointer;color:#111;text-decoration:none;transition:opacity .18s;font-size:22px;line-height:1;flex-shrink:0;padding:0}",
      ".ni-iv-header-home:hover,.ni-iv-close:hover,.ni-iv-header-share:hover{opacity:.6}",
      ".ni-iv-header-right{display:flex;align-items:center;gap:2px}",
      ".ni-iv-header-logo{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);height:26px;max-width:150px;object-fit:contain;pointer-events:none;display:block}",
      /* progress */
      ".ni-iv-progress{position:fixed;top:76px;left:12px;right:12px;z-index:100001;display:flex;gap:4px;pointer-events:none}",
      ".ni-iv-prog-seg{flex:1;height:3px;border-radius:2px;background:rgba(255,255,255,.3);transition:background .3s}",
      ".ni-iv-prog-seg.is-active{background:#fff}",
      ".ni-light .ni-iv-prog-seg{background:rgba(0,0,0,.18)}",
      ".ni-light .ni-iv-prog-seg.is-active{background:#111}",
      /* counter + nav */
      ".ni-iv-counter{position:fixed;top:20px;left:50%;transform:translateX(-50%);z-index:100002;font-size:13px;color:#fff;font-weight:500;pointer-events:none;text-shadow:0 1px 6px rgba(0,0,0,.5)}",
      ".ni-light .ni-iv-counter{color:#333;text-shadow:none}",
      ".ni-iv-prev,.ni-iv-next{position:fixed;top:50%;transform:translateY(-50%);z-index:100001;background:rgba(255,255,255,.92);border:0;border-radius:50%;width:48px;height:48px;font-size:1.8rem;cursor:pointer;color:#111;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 16px rgba(0,0,0,.18);transition:background .15s;line-height:1}",
      ".ni-iv-prev:hover,.ni-iv-next:hover{background:#fff}",
      ".ni-iv-prev{left:24px}.ni-iv-next{right:24px}",
      ".ni-iv-prev:disabled,.ni-iv-next:disabled{opacity:.3;cursor:default}",
      /* mobile feed */
      ".ni-iv-feed{height:100vh;height:100dvh;overflow-y:auto;scroll-snap-type:y mandatory;scrollbar-width:none;max-width:560px;margin:0 auto;-webkit-overflow-scrolling:touch}",
      ".ni-iv-feed::-webkit-scrollbar{display:none}",
      ".ni-iv-post{height:100vh;height:100dvh;scroll-snap-align:start;position:relative;overflow:hidden}",
      ".ni-iv-media{position:absolute;inset:0;background:#000;overflow:hidden}",
      ".ni-iv-img{width:100%;height:100%;object-fit:cover;display:block;transition:opacity .3s ease}",
      /* Mobile: model images have headroom on top — anchor to the bottom so the
         shoes are never cropped; the top is cropped instead. JS also insets the
         media bottom by the collapsed-tray height so the tray never covers them. */
      ".ni-iv-post .ni-iv-img{object-position:center bottom}",
      /* heart burst */
      ".ni-heart-burst{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(.4);font-size:96px;color:#fff;opacity:0;pointer-events:none;z-index:5;text-shadow:0 4px 20px rgba(0,0,0,.4);animation:ni-burst .8s ease}",
      "@keyframes ni-burst{0%{opacity:0;transform:translate(-50%,-50%) scale(.4)}30%{opacity:1;transform:translate(-50%,-50%) scale(1.1)}100%{opacity:0;transform:translate(-50%,-50%) scale(1.3)}}",
      /* desktop dialog */
      ".ni-iv-dialog{display:flex;background:#fff;border-radius:20px;overflow:hidden;width:94%;max-width:880px;height:min(660px,calc(100vh - 110px));box-shadow:0 32px 80px rgba(0,0,0,.5)}",
      ".ni-iv-left{flex:0 0 52%;position:relative;background:#000;height:100%}",
      ".ni-iv-left .ni-iv-media{position:absolute;inset:0}",
      /* Desktop preview: show the WHOLE image (no crop) — letterbox on the black bg */
      ".ni-iv-desktop .ni-iv-img{object-fit:contain}",
      ".ni-iv-right{flex:1 1 auto;display:flex;flex-direction:column;overflow:hidden;background:#fff}",
      ".ni-iv-right-scroll{flex:1 1 auto;overflow-y:auto;padding:24px 24px 8px;scrollbar-width:thin;scrollbar-color:#e0e0e0 transparent}",
      ".ni-iv-cap{font-family:'Caveat',cursive;font-size:1.15rem;color:#444;margin:0 0 18px;line-height:1.4}",
      ".ni-iv-outfit-actions{flex:0 0 auto;padding:14px 24px 20px;border-top:1px solid #f0f0f0;display:flex;flex-direction:column;gap:8px}",
      ".ni-d-atc-all{width:100%;padding:13px 20px;border:0;border-radius:12px;background:#0a0a0a;color:#fff;font-size:.95rem;font-weight:700;cursor:pointer;transition:background .15s;letter-spacing:.01em}",
      ".ni-d-atc-all:hover{background:#333}",
      ".ni-d-atc-all:disabled{background:#ccc;cursor:not-allowed}",
      ".ni-d-shop-link{display:block;text-align:center;padding:11px 20px;border:1.5px solid #0a0a0a;border-radius:12px;color:#0a0a0a;text-decoration:none;font-size:.95rem;font-weight:600;transition:background .15s}",
      ".ni-d-shop-link:hover{background:#f5f5f5}",
      /* trust line */
      ".ni-trust{font-size:11px;color:#888;text-align:center;padding:8px 0 0;line-height:1.4}",
      /* mobile tray */
      ".ni-iv-tray{position:absolute;bottom:0;left:0;right:0;z-index:2;background:#fff;color:#0a0a0a}",
      ".ni-iv-grabber{width:36px;height:4px;border-radius:3px;background:rgba(0,0,0,.18);margin:8px auto 2px}",
      ".ni-iv-tray-bar{display:flex;align-items:center;gap:8px;padding:10px 10px 10px 14px;cursor:pointer;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif}",
      ".ni-iv-tray-pill{display:inline-flex;align-items:center;gap:7px;padding:8px 16px;border-radius:22px;background:rgba(20,20,20,.82);color:#fff;font-size:13px;line-height:1;white-space:nowrap}",
      ".ni-iv-tray.ni-hint .ni-iv-tray-pill{animation:ni-pill-pulse 2.6s ease-in-out infinite;transform-origin:left center}",
      "@keyframes ni-pill-pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.045)}}",
      ".ni-iv-pill-cta{font-weight:800;letter-spacing:.03em}",
      ".ni-iv-pill-count{font-weight:500;color:rgba(255,255,255,.85)}",
      ".ni-iv-tray-icons{margin-left:auto;display:flex;align-items:center}",
      ".ni-iv-tray-icon{background:none;border:none;color:rgba(0,0,0,.6);cursor:pointer;padding:8px 9px;display:flex;align-items:center;justify-content:center;transition:color .2s,transform .12s}",
      ".ni-iv-tray-icon:hover{color:#000}",
      ".ni-iv-tray-icon:active{transform:scale(.85)}",
      ".ni-iv-tray-products{max-height:0;overflow:hidden;transition:max-height .35s ease;padding:0 16px}",
      ".ni-iv-tray.ni-peek .ni-iv-tray-products{max-height:64px;overflow:hidden;padding:0 16px}",
      ".ni-iv-tray.ni-tray-open .ni-iv-tray-products{max-height:52dvh;overflow-y:auto;padding:0 16px 8px}",
      ".ni-iv-tray-products::-webkit-scrollbar{display:none}",
      ".ni-iv-tray-actions{display:none;flex-wrap:wrap;gap:8px;padding:8px 16px 16px}",
      ".ni-iv-tray.ni-tray-open .ni-iv-tray-actions{display:flex}",
      ".ni-m-look-save{flex:0 0 100%;text-align:center;font-size:12.5px;font-weight:700;color:#c0392b;letter-spacing:.01em}",
      ".ni-m-atc-all{flex:1;min-width:0;padding:11px 8px;border:none;border-radius:10px;background:#0a0a0a;color:#fff;font-size:13px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;letter-spacing:.01em}",
      ".ni-m-wl-all{flex:1;min-width:0;padding:11px 8px;border:1px solid rgba(0,0,0,.2);border-radius:10px;background:transparent;color:#0a0a0a;font-size:13px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;letter-spacing:.01em}",
      /* product cards */
      ".ni-card{display:flex;gap:12px;padding:12px 0;border-bottom:1px solid rgba(0,0,0,.08)}",
      ".ni-card:last-child{border-bottom:none}",
      ".ni-card-img-link{display:block;flex:0 0 56px}",
      ".ni-card-img{width:56px;height:56px;object-fit:cover;border-radius:8px;display:block;background:#f5f5f5}",
      ".ni-card-body{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:6px}",
      ".ni-card-header{display:flex;align-items:flex-start;gap:8px;justify-content:space-between}",
      ".ni-card-title{font-size:.82rem;font-weight:600;margin:0;flex:1 1 auto;min-width:0;line-height:1.3}",
      ".ni-card-title a{color:inherit;text-decoration:none}",
      ".ni-card-title a:hover{text-decoration:underline}",
      ".ni-price{font-size:.82rem;font-weight:700;color:#111;white-space:nowrap;margin:0;flex-shrink:0}",
      ".ni-price s{color:#bbb;margin-right:3px;font-weight:400}",
      ".ni-controls{display:flex;gap:6px;align-items:stretch}",
      ".ni-variant{flex:0 0 88px;height:36px;padding:0 22px 0 8px;border:1.5px solid #e0e0e0;border-radius:8px;font-size:.78rem;background:#fafafa url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\") no-repeat right 6px center;appearance:none;cursor:pointer}",
      ".ni-btn{padding:0 10px;height:36px;border:0;border-radius:8px;background:#0a0a0a;color:#fff;font-size:.78rem;font-weight:500;cursor:pointer;white-space:nowrap;transition:background .15s;display:flex;align-items:center;justify-content:center}",
      ".ni-btn:hover{background:#333}",
      ".ni-btn:disabled{background:#ccc;cursor:not-allowed}",
      ".ni-btn[data-add]{flex:1 1 auto}",
      ".ni-btn-notify{flex:1 1 auto;background:#0a0a0a;color:#fff;border:0;font-size:.74rem}",
      ".ni-btn-notify:hover{background:#333}",
      ".ni-btn-wish{flex:0 0 36px;width:36px;padding:0;background:#fff;color:#111;border:1.5px solid #e0e0e0;font-size:1.1rem}",
      ".ni-btn-wish:hover{border-color:#c33;color:#c33;background:#fff}",
      ".ni-btn-wish.ni-fav-on{border-color:#c33;color:#c33}",
      /* desktop dialog: editorial premium product panel */
      ".ni-iv-desktop .ni-iv-right-scroll{padding:22px 22px 8px}",
      ".ni-d-head{margin:0 0 16px}",
      ".ni-d-eyebrow{font-size:.62rem;text-transform:uppercase;letter-spacing:.16em;font-weight:700;color:#9a9a9a;margin:0 0 6px;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif}",
      ".ni-iv-desktop .ni-iv-cap{font-size:1.5rem;color:#161616;margin:0;line-height:1.2}",
      ".ni-iv-desktop .ni-card{gap:14px;padding:16px 0}",
      ".ni-iv-desktop .ni-card-img-link{flex:0 0 66px}",
      ".ni-iv-desktop .ni-card-img{width:66px;height:66px;border-radius:10px}",
      ".ni-iv-desktop .ni-card-body{gap:7px}",
      ".ni-card-titlewrap{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:2px}",
      ".ni-card-brand{font-size:.6rem;text-transform:uppercase;letter-spacing:.07em;color:#9a9a9a;font-weight:700;margin:0;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif}",
      ".ni-iv-desktop .ni-card-header{flex-direction:column;align-items:flex-start;gap:3px}",
      ".ni-iv-desktop .ni-card-title{font-size:.86rem;font-weight:600;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;white-space:normal}",
      ".ni-iv-desktop .ni-price{font-size:.9rem;text-align:left}",
      ".ni-size-label{display:flex;align-items:center;font-size:.6rem;color:#999;font-weight:700;text-transform:uppercase;letter-spacing:.05em;flex:0 0 auto}",
      ".ni-iv-desktop .ni-variant{height:34px;flex:0 0 82px;font-size:.8rem;font-weight:600}",
      ".ni-iv-desktop .ni-btn{height:34px;font-size:.74rem;padding:0 11px}",
      ".ni-iv-desktop .ni-btn-notify{font-size:.7rem}",
      ".ni-iv-desktop .ni-btn-wish{flex:0 0 34px;width:34px;font-size:1rem}",
      ".ni-card-view{display:inline-block;margin-top:2px;font-size:.72rem;color:#666;text-decoration:none;border-bottom:1px solid #dcdcdc;padding-bottom:1px;transition:color .15s,border-color .15s;align-self:flex-start}",
      ".ni-card-view:hover{color:#000;border-color:#000}",
      ".ni-iv-desktop .ni-iv-outfit-actions{padding:14px 22px 18px}",
      ".ni-d-look-total{display:flex;align-items:baseline;justify-content:space-between;gap:10px;margin-bottom:2px}",
      ".ni-d-lt-label{font-size:.9rem;color:#777;font-weight:500}",
      ".ni-d-lt-val{font-size:1rem;font-weight:800;color:#0a0a0a}",
      ".ni-d-lt-save{font-size:.78rem;font-weight:700;color:#c0392b;white-space:nowrap}",
      ".ni-iv-desktop .ni-d-atc-all{font-size:.9rem;padding:13px 18px}",
      ".ni-iv-desktop .ni-d-shop-link{font-size:.84rem;padding:10px 18px}",
      ".ni-iv-desktop .ni-trust{font-size:10px}",
      ".ni-loading{color:#aaa;font-size:13px;padding:12px 0;margin:0}",
      /* size-confirm popup */
      ".ni-confirm{position:fixed;inset:0;z-index:100003;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;backdrop-filter:blur(4px)}",
      ".ni-confirm-box{background:#fff;border-radius:18px;padding:24px;max-width:380px;width:92%;position:relative}",
      ".ni-confirm-title{font-size:1.1rem;font-weight:700;margin:0 0 16px}",
      ".ni-confirm-list{list-style:none;margin:0 0 18px;padding:0;display:flex;flex-direction:column;gap:8px}",
      ".ni-confirm-list li{display:flex;justify-content:space-between;align-items:center;gap:10px;font-size:.88rem;padding:8px 10px;background:#f7f7f7;border-radius:8px}",
      ".ni-confirm-product{flex:1 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}",
      ".ni-confirm-select{flex:0 0 auto;max-width:120px;padding:5px 26px 5px 9px;border:1.5px solid #dcdcdc;border-radius:8px;font-size:.82rem;font-weight:600;background:#fff url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\") no-repeat right 7px center;appearance:none;cursor:pointer}",
      ".ni-confirm-select:focus{outline:none;border-color:#111}",
      ".ni-confirm-select option:disabled{color:#bbb}",
      ".ni-confirm-actions{display:flex;gap:10px;justify-content:flex-end}",
      ".ni-confirm-cancel{padding:10px 16px;border:1.5px solid #111;border-radius:10px;background:#fff;cursor:pointer;font-size:.85rem;font-weight:600}",
      ".ni-confirm-go{padding:10px 16px;border:0;border-radius:10px;background:#0a0a0a;color:#fff;cursor:pointer;font-size:.85rem;font-weight:700}",
      /* toast */
      ".ni-toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:100004;background:rgba(20,20,20,.92);color:#fff;padding:10px 18px;border-radius:22px;font-size:13px;animation:ni-fadein .2s ease}",
      /* size chart button + modal */
      ".ni-card-footer{display:flex;align-items:center;justify-content:space-between;margin-top:3px}",
      ".ni-sc-btn{display:none;background:none;border:1px solid #d0d0d0;border-radius:20px;color:#555;cursor:pointer;padding:3px 9px;font-size:.7rem;font-weight:500;letter-spacing:.01em;transition:color .15s,border-color .15s;align-items:center;gap:3px}",
      ".ni-sc-btn:hover{color:#111;border-color:#888}",
      ".ni-sc-modal{position:fixed;inset:0;z-index:100010;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center}",
      ".ni-sc-dialog{background:#fff;border-radius:16px;max-width:480px;width:92%;max-height:80vh;overflow:hidden;display:flex;flex-direction:column}",
      ".ni-sc-header{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #f0f0f0;flex-shrink:0}",
      ".ni-sc-title{font-size:15px;font-weight:600;margin:0}",
      ".ni-sc-close{background:none;border:none;font-size:22px;cursor:pointer;color:#aaa;line-height:1}",
      ".ni-sc-body{padding:16px 20px;overflow-y:auto;flex:1}",
      ".ni-sc-body table{width:100%;border-collapse:collapse;font-size:13px}",
      ".ni-sc-body th,.ni-sc-body td{padding:8px;border:1px solid #e0e0e0;text-align:center}",
      ".ni-sc-body th{background:#f5f5f5;font-weight:600}"
    ].join("");
    document.head.appendChild(style);
  }

  /* ── Product fetch cache ──────────────────────────────────────────────────── */
  var _cache = {};
  function _fetchProducts(handles) {
    var toFetch = handles.filter(function (h) { return h && !_cache[h]; });
    return Promise.all(
      toFetch.map(function (h) {
        return fetch("/products/" + encodeURIComponent(h) + ".js")
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { if (p) _cache[h] = p; })
          .catch(function () {});
      })
    ).then(function () {
      return handles.map(function (h) { return _cache[h]; }).filter(Boolean);
    });
  }

  /* Shopify /products/<handle>.js returns images as URL strings (and
   * featured_image as a string), NOT {src} objects. */
  function _productImage(product) {
    if (!product) return "";
    if (product.featured_image) return product.featured_image;
    var imgs = product.images || [];
    var first = imgs[0];
    if (!first) return "";
    return typeof first === "string" ? first : (first.src || "");
  }

  /* ── Money formatting ─────────────────────────────────────────────────────── */
  function _money(cents) {
    if (cents == null) return "";
    try {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
      return new Intl.NumberFormat(undefined, { style: "currency", currency: cur }).format(cents / 100);
    } catch (e) {
      return "€" + (cents / 100).toFixed(2);
    }
  }

  function _esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function _toast(msg) {
    var t = document.createElement("div");
    t.className = "ni-toast";
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 1800);
  }

  /* ── Size chart ───────────────────────────────────────────────────────────── */
  var _SIZECHART_BASE = "https://shopify-sync-app-h36w.onrender.com";

  function _fetchSizeChart(product) {
    var params = [];
    var tags = Array.isArray(product.tags) ? product.tags.join(",") : (product.tags || "");
    if (tags) params.push("tags=" + encodeURIComponent(tags));
    if (product.title) params.push("title=" + encodeURIComponent(product.title));
    if (product.product_type) params.push("type=" + encodeURIComponent(product.product_type));
    if (product.vendor) params.push("vendor=" + encodeURIComponent(product.vendor));
    if (!params.length) return Promise.resolve(null);
    return fetch(_SIZECHART_BASE + "/size-charts/api/chart?" + params.join("&"))
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function _showNiSizeChart(chart) {
    var existing = document.getElementById("ni-sc-modal");
    if (existing) existing.remove();
    var modal = document.createElement("div");
    modal.id = "ni-sc-modal";
    modal.className = "ni-sc-modal";
    modal.innerHTML =
      '<div class="ni-sc-dialog">' +
        '<div class="ni-sc-header">' +
          '<span class="ni-sc-title">' + _esc(chart.name || _t.sizeGuide) + "</span>" +
          '<button class="ni-sc-close">&times;</button>' +
        "</div>" +
        '<div class="ni-sc-body">' + (chart.html_table || "") + "</div>" +
      "</div>";
    modal.querySelector(".ni-sc-close").addEventListener("click", function () { modal.remove(); });
    modal.addEventListener("click", function (e) { if (e.target === modal) modal.remove(); });
    document.body.appendChild(modal);
  }

  /* ── Product card builder ─────────────────────────────────────────────────── */
  function _buildCard(product) {
    var img = _productImage(product);
    var opts = "";
    (product.variants || []).forEach(function (v) {
      opts +=
        '<option value="' + v.id + '"' +
        ' data-available="' + (v.available ? "true" : "false") + '"' +
        ' data-price="' + _esc(_money(v.price)) + '"' +
        ' data-price-cents="' + (v.price || 0) + '"' +
        ' data-cmp-cents="' + (v.compare_at_price > v.price ? v.compare_at_price : 0) + '"' +
        ' data-sku="' + _esc(v.sku || "") + '"' +
        ' data-cmp="' + (v.compare_at_price > v.price ? _esc(_money(v.compare_at_price)) : "") + '">' +
        _esc(v.title) + "</option>";
    });
    var brand = product.vendor || "";
    var hUrl = "/products/" + _esc(product.handle);
    var card = document.createElement("div");
    card.className = "ni-card";
    card.setAttribute("data-product", product.id);
    card.setAttribute("data-handle", product.handle);
    card.setAttribute("data-title", product.title);
    card.setAttribute("data-vendor", brand);
    card.setAttribute("data-image", img || "");
    card.innerHTML =
      '<a class="ni-card-img-link" href="' + hUrl + '" tabindex="-1">' +
        '<img class="ni-card-img" src="' + _esc(img) + '" alt="' + _esc(product.title) + '" loading="lazy">' +
      "</a>" +
      '<div class="ni-card-body">' +
        '<div class="ni-card-header">' +
          '<div class="ni-card-titlewrap">' +
            (brand ? '<p class="ni-card-brand">' + _esc(brand) + "</p>" : "") +
            '<p class="ni-card-title"><a href="' + hUrl + '">' + _esc(product.title) + "</a></p>" +
          "</div>" +
          '<p class="ni-price"></p>' +
        "</div>" +
        '<div class="ni-controls">' +
          (_isDesktop ? '<span class="ni-size-label">' + _esc(_t.sizeLabel) + "</span>" : "") +
          '<select class="ni-variant" onchange="NativeImm._syncCard(this, true)">' + opts + "</select>" +
          '<button type="button" class="ni-btn" data-add onclick="NativeImm._addOne(this)">+ ' + _t.add + "</button>" +
          '<button type="button" class="ni-btn ni-btn-notify" data-notify onclick="NativeImm._notify(this)" style="display:none">' + _t.notify + "</button>" +
          '<button type="button" class="ni-btn ni-btn-wish" data-fav onclick="NativeImm._fav(this)" aria-label="Save">&#9825;</button>' +
        "</div>" +
        (_isDesktop ?
          '<div class="ni-card-footer">' +
            '<button type="button" class="ni-sc-btn" aria-label="' + _esc(_t.sizeGuide) + '">' +
              '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M2 20h20M6 4v16M10 8v12M14 12v8M18 6v14"/></svg>' +
              _esc(_t.sizeGuide) +
            "</button>" +
            '<a class="ni-card-view" href="' + hUrl + '">' + _esc(_t.viewProduct) + " →</a>" +
          "</div>"
        : "") +
      "</div>";
    _syncCard(card.querySelector(".ni-variant"));
    return card;
  }

  function _syncCard(sel, keepSelection) {
    if (!sel) return;
    // On initial build, default to the first available size. On a user change
    // (keepSelection), respect their pick — even a sold-out one — so the button
    // can switch to the back-in-stock CTA instead of silently reverting.
    if (!keepSelection) {
      var firstAvail = -1;
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].getAttribute("data-available") === "true") { firstAvail = i; break; }
      }
      var curOpt = sel.options[sel.selectedIndex];
      if (sel.selectedIndex < 0 || (curOpt && curOpt.getAttribute("data-available") !== "true")) {
        if (firstAvail >= 0) sel.selectedIndex = firstAvail;
      }
    }
    var card = sel.closest(".ni-card");
    if (!card) return;
    var opt = sel.options[sel.selectedIndex];
    var available = opt && opt.getAttribute("data-available") === "true";
    var addBtn = card.querySelector("[data-add]");
    var notifyBtn = card.querySelector("[data-notify]");
    if (addBtn) addBtn.style.display = available ? "" : "none";
    if (notifyBtn) notifyBtn.style.display = available ? "none" : "";
    var cmp = opt && opt.getAttribute("data-cmp");
    var priceStr = opt && opt.getAttribute("data-price");
    var priceEl = card.querySelector(".ni-price");
    if (priceEl) priceEl.innerHTML = (cmp ? "<s>" + _esc(cmp) + "</s> " : "") + _esc(priceStr || "");
    if (_isDesktop) {
      var rightC = card.closest(".ni-iv-right");
      if (rightC) _updateLookTotal(rightC);
    } else {
      var trayC = card.closest(".ni-iv-tray");
      if (trayC) _updateMobileSaving(trayC);
    }
  }

  /* ── Look totals (sum of selected variants) ──────────────────────────────── */
  function _lookTotals(container) {
    var total = 0, save = 0;
    container.querySelectorAll(".ni-card").forEach(function (card) {
      var sel = card.querySelector(".ni-variant");
      var opt = sel && sel.options[sel.selectedIndex];
      if (!opt) return;
      var pc = parseInt(opt.getAttribute("data-price-cents") || "0", 10);
      var cc = parseInt(opt.getAttribute("data-cmp-cents") || "0", 10);
      if (pc > 0) total += pc;
      if (cc > pc) save += (cc - pc);
    });
    return { total: total, save: save };
  }

  /* ── Desktop look-total summary + CTA price (premium panel) ───────────────── */
  function _updateLookTotal(right) {
    if (!_isDesktop || !right) return;
    var cards = right.querySelectorAll(".ni-card");
    if (!cards.length) return;
    var t = _lookTotals(right);
    var actions = right.querySelector(".ni-iv-outfit-actions");
    if (!actions) return;
    var ltBox = actions.querySelector(".ni-d-look-total");
    var ltVal = actions.querySelector(".ni-d-lt-val");
    var ltSave = actions.querySelector(".ni-d-lt-save");
    var atc = actions.querySelector(".ni-d-atc-all");
    if (ltBox) ltBox.style.display = t.total > 0 ? "" : "none";
    if (ltVal) ltVal.textContent = _money(t.total);
    if (ltSave) ltSave.textContent = t.save > 0 ? (_t.saveAmt + " " + _money(t.save)) : "";
    if (atc) atc.textContent = t.total > 0 ? (_t.addLookCart + " — " + _money(t.total)) : _t.addLookCart;
  }

  /* ── Mobile tray: cumulated saving line above the add-look button ─────────── */
  function _updateMobileSaving(tray) {
    if (!tray) return;
    var prods = tray.querySelector(".ni-iv-tray-products");
    var el = tray.querySelector(".ni-m-look-save");
    if (!prods || !el) return;
    var t = _lookTotals(prods);
    if (t.save > 0) { el.textContent = _t.saveAmt + " " + _money(t.save); el.style.display = ""; }
    else { el.style.display = "none"; }
  }

  /* ── Cart helpers ─────────────────────────────────────────────────────────── */
  function _cartAdd(lines) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: lines, sections: "cart-drawer", sections_url: window.location.pathname })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { return Promise.reject(d); });
      return r.json();
    });
  }

  function _refreshCart(result) {
    try {
      var html = result && result.sections && result.sections["cart-drawer"];
      if (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.getElementById("cart-drawer");
        var cur = document.getElementById("cart-drawer");
        if (fresh && cur) cur.replaceWith(fresh);
      }
    } catch (e) {}
    var drawer = document.getElementById("cart-drawer");
    if (drawer) {
      if (typeof drawer.show === "function") drawer.show();
      else drawer.setAttribute("open", "");
    }
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll(".cart-count-bubble span,.cart-count,[data-cart-count],#cart-icon-bubble span").forEach(function (n) { n.textContent = c.item_count; });
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: c }));
      })
      .catch(function () {});
  }

  function _collectLines(container) {
    var lines = [];
    container.querySelectorAll(".ni-card").forEach(function (card) {
      var sel = card.querySelector(".ni-variant");
      var opt = sel && sel.options[sel.selectedIndex];
      if (opt && opt.getAttribute("data-available") === "true") {
        lines.push({ id: Number(opt.value), quantity: 1, title: card.getAttribute("data-title") || "", size: (opt.textContent || "").trim() });
      }
    });
    return lines;
  }

  function _doAddAll(lines, btn) {
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = _t.adding;
    _cartAdd(lines.map(function (l) { return { id: l.id, quantity: 1 }; }))
      .then(function (result) {
        btn.textContent = _t.added;
        _refreshCart(result);
        _ga("add_look_to_cart", { source: "look_immersive", products: lines.length });
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2500);
      })
      .catch(function () { btn.textContent = orig; btn.disabled = false; });
  }

  function _addAllFromContainer(container, btn) {
    var lines = _collectLines(container);
    if (!lines.length) { alert(_t.noSize); return; }
    if (_cfg.cartConfirm) {
      _showSizeConfirm(container, btn);
    } else {
      _doAddAll(lines, btn);
    }
  }

  /* ── Size-confirmation popup ──────────────────────────────────────────────── */
  function _showSizeConfirm(container, btn) {
    var existing = document.querySelector(".ni-confirm");
    if (existing) existing.remove();

    // Collect all cards with their selects so the popup can offer dropdowns
    var cardData = [];
    container.querySelectorAll(".ni-card").forEach(function (card) {
      var origSel = card.querySelector(".ni-variant");
      if (!origSel) return;
      var title = card.getAttribute("data-title") || "";
      var opts = Array.from(origSel.options).map(function (o) {
        var avail = o.getAttribute("data-available") === "true";
        return '<option value="' + _esc(o.value) + '"' +
          (!avail ? ' disabled class="ni-oos-opt"' : "") +
          (o.selected ? " selected" : "") + ">" +
          _esc((o.textContent || "").trim()) + (avail ? "" : " ✕") + "</option>";
      }).join("");
      cardData.push({ title: title, opts: opts, origSel: origSel });
    });

    var rows = cardData.map(function (d) {
      return "<li>" +
        '<span class="ni-confirm-product">' + _esc(d.title) + "</span>" +
        '<select class="ni-confirm-select">' + d.opts + "</select>" +
      "</li>";
    }).join("");

    var overlay = document.createElement("div");
    overlay.className = "ni-confirm";
    overlay.innerHTML =
      '<div class="ni-confirm-box">' +
        '<h3 class="ni-confirm-title">' + _t.confirmTitle + "</h3>" +
        '<ul class="ni-confirm-list">' + rows + "</ul>" +
        '<div class="ni-confirm-actions">' +
          '<button type="button" class="ni-confirm-cancel">' + _t.cancel + "</button>" +
          '<button type="button" class="ni-confirm-go">' + _t.confirmBtn + "</button>" +
        "</div>" +
      "</div>";

    overlay.addEventListener("click", function (e) { if (e.target === overlay) overlay.remove(); });
    overlay.querySelector(".ni-confirm-cancel").addEventListener("click", function () { overlay.remove(); });
    overlay.querySelector(".ni-confirm-go").addEventListener("click", function () {
      // Sync popup selections back to the product card selects, then add to cart
      var confirmSelects = overlay.querySelectorAll(".ni-confirm-select");
      confirmSelects.forEach(function (sel, i) {
        if (cardData[i] && cardData[i].origSel && sel.value) {
          cardData[i].origSel.value = sel.value;
          cardData[i].origSel.dispatchEvent(new Event("change"));
        }
      });
      overlay.remove();
      var lines = _collectLines(container);
      if (lines.length) _doAddAll(lines, btn);
    });

    document.body.appendChild(overlay);
  }

  /* ── Wishlist helper ──────────────────────────────────────────────────────── */
  function _niEmailModal(onSubmit) {
    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:2147483001;display:flex;align-items:center;justify-content:center';
    var box = document.createElement('div');
    box.style.cssText = 'background:#fff;border-radius:12px;padding:28px 24px;max-width:340px;width:90%;box-sizing:border-box;font-family:inherit';
    box.innerHTML =
      '<p style="margin:0 0 6px;font-size:17px;font-weight:600">' + (_t.saveWishlist || 'Save to Wishlist') + '</p>' +
      '<p style="margin:0 0 14px;font-size:13px;color:#666">' + (_t.enterEmailSave || 'Enter your email to save') + '</p>' +
      '<input type="email" placeholder="email@example.com" style="width:100%;box-sizing:border-box;border:1px solid #ddd;border-radius:8px;padding:10px 12px;font-size:15px;margin-bottom:14px">' +
      '<div style="display:flex;gap:10px;justify-content:flex-end">' +
        '<button style="border:none;background:none;padding:10px 16px;font-size:14px;cursor:pointer;color:#555">' + (_t.cancel || 'Cancel') + '</button>' +
        '<button style="border:none;background:#000;color:#fff;padding:10px 20px;border-radius:8px;font-size:14px;cursor:pointer">' + (_t.save || 'Save') + '</button>' +
      '</div>';
    overlay.appendChild(box);
    document.body.appendChild(overlay);
    var input = box.querySelector('input');
    var btns = box.querySelectorAll('button');
    function close() { overlay.remove(); }
    btns[0].addEventListener('click', function () { close(); onSubmit(null); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) { close(); onSubmit(null); } });
    btns[1].addEventListener('click', function () {
      var em = input.value.trim();
      if (!em || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) { input.style.borderColor = '#c0392b'; return; }
      close(); onSubmit(em);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') btns[1].click(); });
    setTimeout(function () { input.focus(); }, 50);
  }

  function _niStoredEmail() {
    try { var e = localStorage.getItem("integratedWishlistEmail"); return (e && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) ? e : ""; } catch (ex) { return ""; }
  }
  function _niSaveEmail(email) { try { localStorage.setItem("integratedWishlistEmail", email); } catch (ex) {} }
  function _niCustomerId() {
    try { return (window.Shopify && window.Shopify.customer && window.Shopify.customer.id) ? String(window.Shopify.customer.id) : ""; } catch (e) { return ""; }
  }

  function _wishAdd(payload) {
    var body = Object.assign({ shop: location.hostname, source: "native_imm", locale: document.documentElement.lang || "" }, payload);
    try {
      if (window.Shopify && window.Shopify.customer) body.customerId = String(window.Shopify.customer.id || "");
    } catch (e) {}
    return fetch("/apps/wishlist/add", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).catch(function () { return { success: false }; });
  }

  // Reflect shared-wishlist state on immersive hearts.
  document.addEventListener("integrated:wishlist:change", function (e) {
    var detail = e.detail || {};
    if (!detail.handle || !detail.selected) return;
    document.querySelectorAll('.ni-card[data-handle="' + detail.handle + '"] .ni-btn-wish').forEach(function (heart) {
      heart.innerHTML = "&#9829;";
      heart.classList.add("ni-fav-on");
    });
  });

  function _saveLook(container, btn) {
    var payloads = [];
    container.querySelectorAll(".ni-card").forEach(function (card) {
      var sel = card.querySelector(".ni-variant");
      var opt = sel && sel.options[sel.selectedIndex];
      payloads.push({
        productId: String(card.getAttribute("data-product") || ""),
        productHandle: card.getAttribute("data-handle") || "",
        variantId: opt ? String(opt.value) : "",
        selectedSize: opt && opt.value ? (opt.textContent || "").trim() : "",
        source: "look_immersive"
      });
    });
    if (!payloads.length) return;
    var orig = btn.innerHTML;
    btn.disabled = true;
    // Preferred: shared wishlist (single email modal for the whole look).
    if (window.IntegratedWishlist && window.IntegratedWishlist.addItems) {
      window.IntegratedWishlist.addItems(payloads, { title: _t.saveLook || _t.saved }).then(function (res) {
        if (res && res.ok) btn.innerHTML = _t.saved;
        btn.disabled = false;
      }).catch(function () { btn.disabled = false; });
      return;
    }
    // Fallback when the app embed is absent.
    var niEmail = _niStoredEmail();
    function doSaveLook(email) {
      return Promise.all(payloads.map(function (p) { return _wishAdd(Object.assign(email ? { email: email } : {}, p)); }))
        .then(function () { btn.innerHTML = _t.saved; btn.disabled = false; });
    }
    if (!niEmail && !_niCustomerId()) {
      // Guest with no cached email — ask immediately, no API probe needed.
      _niEmailModal(function (em) {
        if (!em) { btn.disabled = false; return; }
        _niSaveEmail(em);
        doSaveLook(em);
      });
      return;
    }
    _wishAdd(Object.assign(niEmail ? { email: niEmail } : {}, payloads[0])).then(function (res) {
      if (!res || !res.success) {
        _niEmailModal(function (em) {
          if (!em) { btn.disabled = false; return; }
          _niSaveEmail(em);
          doSaveLook(em);
        });
        return;
      }
      return Promise.all(payloads.slice(1).map(function (p) { return _wishAdd(Object.assign(niEmail ? { email: niEmail } : {}, p)); }))
        .then(function () { btn.innerHTML = _t.saved; btn.disabled = false; });
    }).catch(function () { btn.disabled = false; });
  }

  /* ── Share ────────────────────────────────────────────────────────────────── */
  function _share(url) {
    var shareUrl = url || window.location.href;
    if (navigator.share) {
      navigator.share({ url: shareUrl }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(shareUrl).then(function () { _toast(_t.linkCopied); }).catch(function () {});
    } else {
      _toast(shareUrl);
    }
  }

  /* ── Media element ────────────────────────────────────────────────────────── */
  function _makeMedia(item, container) {
    if (item.video) {
      var vid = document.createElement("video");
      vid.className = "ni-iv-img";
      vid.src = item.video;
      vid.autoplay = true; vid.muted = true; vid.loop = true; vid.playsInline = true;
      if (item.img) vid.poster = item.img;
      container.appendChild(vid);
    } else {
      var img = document.createElement("img");
      img.className = "ni-iv-img";
      img.src = item.img || "";
      img.alt = item.cap || "";
      img.style.opacity = "0";
      img.onload = function () { img.style.opacity = "1"; };
      img.onerror = function () { img.style.opacity = "1"; };
      container.appendChild(img);
    }
  }

  /* ── assets ───────────────────────────────────────────────────────────────── */
  var _logoUrl = "https://skisises.com/cdn/shop/files/it_skisises_1.svg?v=1690179833&width=280";
  var _homeSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z"/><polyline points="9 21 9 12 15 12 15 21"/></svg>';
  var _shareSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>';
  var _cartSvgSm = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
  var _heartSvgSm = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  var _cartSvgMd = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
  var _heartSvgMd = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  function _trustHtml() {
    return _cfg.doubtRemovers && _cfg.doubtText
      ? '<p class="ni-trust">' + _esc(_cfg.doubtText) + "</p>"
      : "";
  }

  function _headerHtml(origin, showShare) {
    return '<div class="ni-iv-header">' +
      '<a class="ni-iv-header-home" href="' + origin + '/" aria-label="Home">' + _homeSvg + "</a>" +
      '<img class="ni-iv-header-logo" src="' + _logoUrl + '" alt="">' +
      '<div class="ni-iv-header-right">' +
        (showShare && _cfg.deepLinkShare ? '<button class="ni-iv-header-share" aria-label="' + _t.share + '">' + _shareSvg + "</button>" : "") +
        '<button class="ni-iv-close" aria-label="Close">&times;</button>' +
      "</div>" +
    "</div>";
  }

  /* ── Mobile build ─────────────────────────────────────────────────────────── */
  function _buildMobile(items) {
    var origin = window.location.origin || "";
    var viewer = document.createElement("div");
    viewer.id = "ni-iv";
    viewer.className = "ni-iv" + (_cfg.theme === "light" ? " ni-light" : "");
    viewer.innerHTML =
      _headerHtml(origin) +
      (_cfg.progressBar && items.length > 1 ? '<div class="ni-iv-progress"></div>' : "") +
      '<div class="ni-iv-feed"></div>';

    var feed = viewer.querySelector(".ni-iv-feed");
    var progress = viewer.querySelector(".ni-iv-progress");

    if (progress) {
      items.forEach(function (_, i) {
        var seg = document.createElement("div");
        seg.className = "ni-iv-prog-seg" + (i === 0 ? " is-active" : "");
        seg.dataset.i = i;
        progress.appendChild(seg);
      });
    }

    items.forEach(function (item, idx) {
      var post = document.createElement("div");
      post.className = "ni-iv-post";
      post.dataset.idx = idx;

      var media = document.createElement("div");
      media.className = "ni-iv-media";
      _makeMedia(item, media);
      post.appendChild(media);

      var tray = null;
      if (item.handles && item.handles.length) {
        tray = document.createElement("div");
        tray.className = "ni-iv-tray";
        if (_cfg.trayHint) tray.classList.add("ni-hint");
        var count = item.handles.length;
        tray.innerHTML =
          (_cfg.dragTray ? '<div class="ni-iv-grabber"></div>' : "") +
          '<div class="ni-iv-tray-bar">' +
            '<div class="ni-iv-tray-pill">' +
              '<span class="ni-iv-pill-cta">' + _t.view + "</span>" +
              '<span class="ni-iv-pill-count">' + count + " " + (count !== 1 ? _t.products : _t.product) + "</span>" +
            "</div>" +
            '<div class="ni-iv-tray-icons">' +
              (_cfg.deepLinkShare ? '<button class="ni-iv-tray-icon ni-tray-share" aria-label="' + _t.share + '">' + _shareSvg + "</button>" : "") +
              '<button class="ni-iv-tray-icon ni-tray-cart" aria-label="Add look">' + _cartSvgMd + "</button>" +
              '<button class="ni-iv-tray-icon ni-tray-heart" aria-label="Save look">' + _heartSvgMd + "</button>" +
            "</div>" +
          "</div>" +
          '<div class="ni-iv-tray-products"><p class="ni-loading">' + _t.loading + "</p></div>" +
          '<div class="ni-iv-tray-actions">' +
            '<div class="ni-m-look-save" style="display:none"></div>' +
            '<button class="ni-m-atc-all" type="button">' + _cartSvgSm + " " + _t.addLook + "</button>" +
            '<button class="ni-m-wl-all" type="button">' + _heartSvgSm + " " + _t.saveLook + "</button>" +
          "</div>" +
          _trustHtml();

        var trayBar = tray.querySelector(".ni-iv-tray-bar");
        var trayProds = tray.querySelector(".ni-iv-tray-products");
        var cartBtn = tray.querySelector(".ni-tray-cart");
        var heartBtn = tray.querySelector(".ni-tray-heart");
        var trayShareBtn = tray.querySelector(".ni-tray-share");
        var atcAllBtn = tray.querySelector(".ni-m-atc-all");
        var wlAllBtn = tray.querySelector(".ni-m-wl-all");
        var trayLoaded = false;

        function loadTray(cb) {
          if (trayLoaded) { if (cb) cb(); return; }
          trayLoaded = true;
          _fetchProducts(item.handles).then(function (products) {
            trayProds.innerHTML = "";
            if (!products.length) trayProds.innerHTML = '<p style="color:#888;padding:12px 0">No products</p>';
            else products.forEach(function (p) {
              var cardEl = _buildCard(p);
              trayProds.appendChild(cardEl);
              if (_isDesktop) _fetchSizeChart(p).then(function (chart) {
                if (!chart || !chart.html_table) return;
                var btn = cardEl.querySelector(".ni-sc-btn");
                if (btn) { btn._niChart = chart; btn.style.display = "inline-flex"; btn.addEventListener("click", function () { _showNiSizeChart(btn._niChart); }); }
              });
            });
            _updateMobileSaving(tray);
            if (cb) cb();
          });
        }
        // Expose so the IntersectionObserver can warm the products as soon as the
        // post is in view — the tray then opens instantly instead of fetching on tap.
        tray._prefetch = function () { loadTray(null); };

        function openTray() {
          tray.classList.remove("ni-peek", "ni-hint");
          var isOpen = tray.classList.toggle("ni-tray-open");
          if (isOpen) loadTray(null);
        }
        trayBar.addEventListener("click", openTray);

        cartBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          tray.classList.add("ni-tray-open"); tray.classList.remove("ni-peek", "ni-hint");
          loadTray(function () { _addAllFromContainer(trayProds, atcAllBtn); });
        });
        heartBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          tray.classList.add("ni-tray-open"); tray.classList.remove("ni-peek", "ni-hint");
          loadTray(function () { _saveLook(trayProds, wlAllBtn); });
        });
        if (trayShareBtn) trayShareBtn.addEventListener("click", function (e) { e.stopPropagation(); _share(item.url || window.location.href); });
        atcAllBtn.addEventListener("click", function () { _addAllFromContainer(trayProds, atcAllBtn); });
        wlAllBtn.addEventListener("click", function () { _saveLook(trayProds, wlAllBtn); });

        post.appendChild(tray);
      }

      /* double-tap image to save look */
      if (_cfg.doubleTapSave && item.handles && item.handles.length) {
        var lastTap = 0;
        media.addEventListener("click", function (e) {
          var now = Date.now();
          if (now - lastTap < 320) {
            lastTap = 0;
            _showHeartBurst(media);
            if (tray) {
              var t = tray;
              var go = function () { var wl = t.querySelector(".ni-m-wl-all"); if (wl) _saveLook(t.querySelector(".ni-iv-tray-products"), wl); };
              if (t.querySelector(".ni-card")) go();
              else { var bar = t.querySelector(".ni-iv-tray-bar"); if (bar) { bar.click(); setTimeout(go, 400); } }
            }
            return;
          }
          lastTap = now;
        });
      }

      feed.appendChild(post);
    });

    /* Briefly slide the tray up (peek) on whichever post is in view, so the hint
       lands on the look you actually opened — not only the first one. */
    function _peekTray(tray) {
      if (!tray || tray.classList.contains("ni-tray-open")) return;
      tray.classList.add("ni-peek");
      if (tray._peekT) clearTimeout(tray._peekT);
      tray._peekT = setTimeout(function () { tray.classList.remove("ni-peek"); }, 2600);
    }

    /* IntersectionObserver: progress segments + tray peek on the visible post */
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = parseInt(e.target.dataset.idx, 10);
          if (progress) progress.querySelectorAll(".ni-iv-prog-seg").forEach(function (s, j) { s.classList.toggle("is-active", j <= i); });
          var vt = e.target.querySelector(".ni-iv-tray");
          if (vt && vt._prefetch) vt._prefetch();
          if (_cfg.trayHint) _peekTray(vt);
        });
      }, { root: feed, threshold: 0.5 });
      feed.querySelectorAll(".ni-iv-post").forEach(function (p) { io.observe(p); });
      viewer._observer = io;
    } else {
      var ft = feed.querySelector(".ni-iv-tray");
      if (ft && ft._prefetch) ft._prefetch();
      if (_cfg.trayHint) _peekTray(ft);
    }

    viewer.querySelector(".ni-iv-close").addEventListener("click", close);
    viewer._keyHandler = function (e) { if (e.key === "Escape") close(); };
    document.addEventListener("keydown", viewer._keyHandler);
    return viewer;
  }

  function _showHeartBurst(media) {
    var b = document.createElement("div");
    b.className = "ni-heart-burst";
    b.innerHTML = "&#10084;";
    media.appendChild(b);
    setTimeout(function () { b.remove(); }, 800);
  }

  /* ── Desktop build ────────────────────────────────────────────────────────── */
  function _buildDesktop(items, startIdx) {
    var origin = window.location.origin || "";
    var multi = items.length > 1;
    var viewer = document.createElement("div");
    viewer.id = "ni-iv";
    viewer.className = "ni-iv ni-iv-desktop" + (_cfg.theme === "light" ? " ni-light" : "");
    viewer.innerHTML =
      _headerHtml(origin, true) +
      (multi ? '<div class="ni-iv-counter"></div>' : "") +
      (multi ? '<button class="ni-iv-prev" aria-label="Previous">&#8249;</button><button class="ni-iv-next" aria-label="Next">&#8250;</button>' : "") +
      '<div class="ni-iv-dialog"></div>';

    var dialog = viewer.querySelector(".ni-iv-dialog");
    var counter = viewer.querySelector(".ni-iv-counter");
    var prevBtn = viewer.querySelector(".ni-iv-prev");
    var nextBtn = viewer.querySelector(".ni-iv-next");
    var cur = startIdx || 0;

    function navigate(idx) {
      if (idx < 0 || idx >= items.length) return;
      cur = idx;
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx === items.length - 1;
      if (counter) counter.textContent = (idx + 1) + " / " + items.length;
      _renderDialog(dialog, items[idx]);
    }

    if (prevBtn) prevBtn.addEventListener("click", function () { navigate(cur - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { navigate(cur + 1); });
    viewer.addEventListener("click", function (e) { if (e.target === viewer) close(); });
    viewer.querySelector(".ni-iv-close").addEventListener("click", close);
    var shareBtn = viewer.querySelector(".ni-iv-header-share");
    if (shareBtn) shareBtn.addEventListener("click", function () { _share((items[cur] && items[cur].url) || ""); });

    viewer._keyHandler = function (e) {
      if (e.key === "Escape") { close(); return; }
      if (e.key === "ArrowLeft") navigate(cur - 1);
      else if (e.key === "ArrowRight") navigate(cur + 1);
    };
    document.addEventListener("keydown", viewer._keyHandler);

    var wAcc = 0, wTimer = null;
    viewer.addEventListener("wheel", function (e) {
      if (Math.abs(e.deltaX) < Math.abs(e.deltaY) * 0.5) return;
      wAcc += e.deltaX;
      clearTimeout(wTimer);
      wTimer = setTimeout(function () {
        if (wAcc > 60) navigate(cur + 1);
        else if (wAcc < -60) navigate(cur - 1);
        wAcc = 0;
      }, 80);
    }, { passive: true });

    navigate(startIdx || 0);
    return viewer;
  }

  function _renderDialog(dialog, item) {
    dialog.innerHTML = "";

    var left = document.createElement("div");
    left.className = "ni-iv-left";
    var media = document.createElement("div");
    media.className = "ni-iv-media";
    _makeMedia(item, media);
    left.appendChild(media);
    dialog.appendChild(left);

    var right = document.createElement("div");
    right.className = "ni-iv-right";
    var scroll = document.createElement("div");
    scroll.className = "ni-iv-right-scroll";

    // Editorial header: "Shop the look" eyebrow + a more prominent caption.
    var head = document.createElement("div");
    head.className = "ni-d-head";
    head.innerHTML =
      '<p class="ni-d-eyebrow">' + _esc(_t.eyebrow) + "</p>" +
      (item.cap ? '<p class="ni-iv-cap">' + _esc(item.cap) + "</p>" : "");
    scroll.appendChild(head);

    var actions = document.createElement("div");
    actions.className = "ni-iv-outfit-actions";
    actions.style.display = "none";
    actions.innerHTML =
      '<div class="ni-d-look-total" style="display:none">' +
        '<span class="ni-d-lt-main"><span class="ni-d-lt-label">' + _esc(_t.lookTotal) + '</span> <span class="ni-d-lt-val"></span></span>' +
        '<span class="ni-d-lt-save"></span>' +
      "</div>" +
      '<button class="ni-d-atc-all" type="button">' + _t.addLookCart + "</button>" +
      '<a class="ni-d-shop-link" href="' + _esc(item.url || "") + '">' + _t.moreDetails + "</a>" +
      _trustHtml();

    right.appendChild(scroll);
    right.appendChild(actions);
    dialog.appendChild(right);

    if (item.handles && item.handles.length) {
      var loadEl = document.createElement("p");
      loadEl.className = "ni-loading";
      loadEl.textContent = _t.loading;
      scroll.appendChild(loadEl);
      _fetchProducts(item.handles).then(function (products) {
        if (!right.parentNode) return;
        if (loadEl.parentNode) loadEl.remove();
        products.forEach(function (p) {
          var cardEl = _buildCard(p);
          scroll.appendChild(cardEl);
          _fetchSizeChart(p).then(function (chart) {
            if (!chart || !chart.html_table) return;
            var btn = cardEl.querySelector(".ni-sc-btn");
            if (btn) { btn._niChart = chart; btn.style.display = "inline-flex"; btn.addEventListener("click", function () { _showNiSizeChart(btn._niChart); }); }
          });
        });
        if (products.length) { actions.style.display = ""; _updateLookTotal(right); }
      });
    } else if (item.url) {
      actions.style.display = "";
    }

    var atcAllBtn = actions.querySelector(".ni-d-atc-all");
    if (atcAllBtn) atcAllBtn.addEventListener("click", function () { _addAllFromContainer(scroll, atcAllBtn); });
  }

  /* ── Close ────────────────────────────────────────────────────────────────── */
  function close() {
    var v = document.getElementById("ni-iv");
    if (!v) return;
    if (v._keyHandler) document.removeEventListener("keydown", v._keyHandler);
    if (v._observer) v._observer.disconnect();
    v.remove();
    var c = document.querySelector(".ni-confirm"); if (c) c.remove();
    document.body.style.overflow = "";
  }

  /* ── Open ─────────────────────────────────────────────────────────────────── */
  function open(items, startIdx, config) {
    _cfg = Object.assign({}, DEFAULTS, window.NativeImmDefaults || {}, config || {});
    _injectCss();
    close();
    var idx = startIdx || 0;
    var isDesktop = window.innerWidth > 700;
    _isDesktop = isDesktop;
    var viewer = isDesktop ? _buildDesktop(items, idx) : _buildMobile(items);
    document.body.appendChild(viewer);
    document.body.style.overflow = "hidden";

    // Mobile: reserve the collapsed tray's height under each post's image so the
    // bottom of the photo (the shoes) sits just above the tray instead of behind
    // it. Measured once now while every tray is still collapsed.
    if (!isDesktop) {
      viewer.querySelectorAll(".ni-iv-post").forEach(function (post) {
        var tray = post.querySelector(".ni-iv-tray");
        var media = post.querySelector(".ni-iv-media");
        if (!tray || !media) return;
        var h = tray.offsetHeight;
        if (h > 0) media.style.bottom = h + "px";
      });
    }
    _ga("look_carousel_open", {
      source: "look_immersive",
      device: isDesktop ? "desktop" : "mobile",
      items: items ? items.length : 0,
      start_index: idx
    });

    if (!isDesktop && idx > 0) {
      var feed = viewer.querySelector(".ni-iv-feed");
      var posts = feed && feed.querySelectorAll(".ni-iv-post");
      if (posts && posts[idx]) setTimeout(function () { posts[idx].scrollIntoView({ behavior: "instant" }); }, 0);
    }
  }

  /* ── openFromEl: gather sibling polaroids → items, resolve config, open ───── */
  function openFromEl(el, event) {
    if (event) event.preventDefault();
    var config = _resolveConfig(el);
    var parent = el.parentNode;
    var siblings = parent
      ? [].slice.call(parent.children).filter(function (c) { return c.hasAttribute && (c.hasAttribute("data-imm-img") || c.hasAttribute("data-imm-url")); })
      : [el];
    var startIdx = siblings.indexOf(el);
    if (startIdx < 0) startIdx = 0;

    var items = siblings.map(function (s) {
      return {
        img: s.getAttribute("data-imm-img") || "",
        cap: s.getAttribute("data-imm-cap") || "",
        url: s.getAttribute("data-imm-url") || s.href || "",
        video: s.getAttribute("data-imm-video") || "",
        handles: (s.getAttribute("data-imm-handles") || "").split(",").map(function (h) { return h.trim(); }).filter(Boolean)
      };
    });
    open(items, startIdx, config);
  }

  /* ── Public API ───────────────────────────────────────────────────────────── */
  window.NativeImm = {
    open: open,
    openFromEl: openFromEl,
    close: close,
    _syncCard: _syncCard,
    _addOne: function (btn) {
      var card = btn.closest(".ni-card");
      var sel = card && card.querySelector(".ni-variant");
      var opt = sel && sel.options[sel.selectedIndex];
      if (!opt || opt.getAttribute("data-available") !== "true") return;
      var orig = btn.textContent;
      btn.disabled = true;
      _cartAdd([{ id: Number(opt.value), quantity: 1 }])
        .then(function (result) {
          btn.textContent = "✓";
          _refreshCart(result);
          _ga("add_to_cart", {
            source: "look_immersive",
            item_id: card ? card.getAttribute("data-product") : "",
            variant_id: String(opt.value),
            item_name: card ? card.getAttribute("data-title") : ""
          });
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
        })
        .catch(function (err) {
          btn.disabled = false;
          // Draft/archived products return 422. Fall back to the BIS flow so the user can
          // subscribe for availability instead of seeing a bare error alert.
          var notifyBtn = card && card.querySelector("[data-notify]");
          if (notifyBtn) {
            var addBtn = card && card.querySelector("[data-add]");
            if (addBtn) addBtn.style.display = "none";
            notifyBtn.style.display = "";
            NativeImm._notify(notifyBtn);
          } else {
            alert((err && (err.description || err.message)) || "Could not add to cart");
          }
        });
    },
    _notify: function (btn) {
      var card = btn.closest(".ni-card");
      var sel = card && card.querySelector(".ni-variant");
      var opt = sel && sel.options[sel.selectedIndex];
      if (!card) return;
      _ga("back_in_stock_open", {
        source: "look_immersive",
        item_id: card.getAttribute("data-product"),
        variant_id: opt ? String(opt.value) : ""
      });
      if (!window.SkiSisesBisMini) { alert(_t.notify); return; }
      window.SkiSisesBisMini.open({
        productId: card.getAttribute("data-product") || "",
        productHandle: card.getAttribute("data-handle") || "",
        productTitle: card.getAttribute("data-title") || "",
        productVendor: card.getAttribute("data-vendor") || "",
        productImage: card.getAttribute("data-image") || "",
        variantId: opt ? String(opt.value) : "",
        variantTitle: opt ? (opt.textContent || "").trim() : "",
        sku: opt ? (opt.getAttribute("data-sku") || "") : "",
        price: opt ? (opt.getAttribute("data-price") || "") : ""
      });
    },
    _fav: function (btn) {
      var card = btn.closest(".ni-card");
      if (!card) return;
      var sel = card.querySelector(".ni-variant");
      var opt = sel && sel.options[sel.selectedIndex];
      var productId = String(card.getAttribute("data-product") || "");
      var handle = card.getAttribute("data-handle") || "";
      _ga("save_product", { source: "look_immersive", item_id: productId });
      // Preferred: reuse the shared wishlist modal (size picker + email capture).
      if (handle && window.IntegratedWishlist && window.IntegratedWishlist.open) {
        window.IntegratedWishlist.open({ handle: handle, productId: productId, source: "look_immersive", button: btn });
        return;
      }
      // Fallback when the app embed is absent.
      var payload = { productId: productId, productHandle: handle, variantId: opt ? String(opt.value) : "" };
      var niCachedEmail = _niStoredEmail();
      if (niCachedEmail) payload.email = niCachedEmail;
      // Guest with no cached email — show modal immediately, no API probe needed.
      if (!niCachedEmail && !_niCustomerId()) {
        _niEmailModal(function (em) {
          if (!em) return;
          _niSaveEmail(em);
          _wishAdd(Object.assign({ email: em }, payload)).then(function (r2) {
            if (r2 && r2.success) { btn.innerHTML = "&#9829;"; btn.classList.add("ni-fav-on"); }
          });
        });
        return;
      }
      _wishAdd(payload).then(function (res) {
        if (res && res.success) { btn.innerHTML = "&#9829;"; btn.classList.add("ni-fav-on"); }
        else {
          _niEmailModal(function (em) {
            if (!em) return;
            _niSaveEmail(em);
            _wishAdd(Object.assign({ email: em }, payload)).then(function (r2) {
              if (r2 && r2.success) { btn.innerHTML = "&#9829;"; btn.classList.add("ni-fav-on"); }
            });
          });
        }
      }).catch(function () {});
    }
  };
})();
